module.exports = __webpack_public_path__ + "img/workspace.0c41eae6.png";